import { processResponse } from 'Fetch';
import { getMOTVehicleCheck, postMotNotifications } from 'PrivateApis';

import { MOT_CHECKER_CONTRACT_TEST_ENDPOINT_PATH, MOT_NOTIFICATIONS_CONTRACT_TEST_ENDPOINT_PATH } from './motAPI.helpers';

type GetMOTCheckerProps = {
  opts?: {
    abortController?: AbortController;
    isContractTesting?: boolean;
  };
  setStatusCode?: (status?: number) => void;
  vrm: string;
};

type PostMOTNotificationsProp = {
  opts?: {
    abortController?: AbortController;
    isContractTesting?: boolean;
  };
  payload: { dpSellerId: number; vrm: string };
  setStatusCode?: (status?: number) => void;
}

const env = process.env.APPLICATION_ENVIRONMENT === 'production' ? 'prod' : 'stage';

export const getMOTChecker = ({
  opts = { abortController: undefined, isContractTesting: false },
  setStatusCode,
  vrm,
}: GetMOTCheckerProps) => {
  const { abortController, isContractTesting } = opts;

  if (isContractTesting) {
    return fetch(`${MOT_CHECKER_CONTRACT_TEST_ENDPOINT_PATH}/${vrm}`)
      .then(async (res) => {
        await setStatusCode?.(res.status);
        return processResponse(res, undefined);
      });
  }

  return getMOTVehicleCheck(vrm, env, setStatusCode, abortController);
};

export const postNotifications = ({
  opts = { abortController: undefined, isContractTesting: false },
  payload,
  setStatusCode,
}: PostMOTNotificationsProp) => {
  const { abortController, isContractTesting } = opts;

  if (isContractTesting) {
    return fetch(MOT_NOTIFICATIONS_CONTRACT_TEST_ENDPOINT_PATH, {
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })
      .then(async (res) => {
        await setStatusCode?.(res.status);
        return processResponse(res, undefined);
      });
  }

  return postMotNotifications(payload, env, setStatusCode, abortController);
};
